export const moduleId = "declaration-classified-income";
import api from '../../../api/consolidated-income-tax-statement/incomeWrite/index'
import UserPersistence from '../../../persistence/UserPersistence'
import {setMessage} from '../../../libs/message';

export const state = {


  params: {
    sourceCode: null, //	登录唯一标识
    abId: null, //账套id（所属机构）
    year: null, //所属年度
    month: null, ////所属月份
    operator: null
  },
  stepName: 'first',
  interestDialog: false,
  interestTitleFlag: "add",
  interestdetailData: null,
  transferDialog: false,
  transferTitleFlag: "add",
  transferdetailData: null,
  leaseDialog: false,
  accidentalDialog: false,
  leaseFlag: "add",
  accidentalFlag: "add",
  leaseData: null,
  accidentalData: null,
};

export const actions = {
  async queryTotalTax({state, commit, dispatch}) {
    let query = {
      ...state.params,

    }
    let res = await api.totalTax(query)
    if (!res.code) {
      commit('setTotalTax', res.data);

    } else {
      setMessage({type: "error", message: res.msg})
    }
  },


};

export const mutations = {
  setStepName(state, falg) {
    state.stepName = falg
  },
  setLeaseDialog(state, falg) {
    state.leaseDialog = falg
  },
  setAccidentalDialog(state, falg) {
    state.accidentalDialog = falg
  },
  setParams(state, params) {
    state.params.year = params.year,
      state.params.month = params.month
    state.params.sourceCode = params.sourceCode,
      state.params.abId = params.abId,
      state.params.operator = params.operator

  },

  setInterestDialog(state, falg) {
    state.interestDialog = falg
  },
  setInterestTitleFlag(state, falg) {
    state.interestTitleFlag = falg
  },
  setInterestDetailData(state, data) {
    state.interestdetailData = data
  },

  setTransferDialog(state, falg) {
    state.transferDialog = falg
  },
  setTransferTitleFlag(state, falg) {
    state.transferTitleFlag = falg
  },
  setTransferDetailData(state, data) {
    state.transferdetailData = data
  },
  setLeaseData(state, data) {
    state.leaseData = data
  },
  setAccidentalData(state, data) {
    state.accidentalData = data
  },
  setLeaseFlag(state, falg) {
    state.leaseFlag = falg
  },
  setAccidentalFlag(state, falg) {
    state.accidentalFlag = falg
  },
  setLabourDetailData(state, data) {
    state.labourDetailData = data

  },
  setTotalTax(state, data) {
    state.totalTaxData = data
  },

  setDetailDialog(state, data) {
    if (data.type === 'interest') {
      state.interestDetailDialog = data.flag
    } else if (data.type === 'taxcel') {
      state.taxcelDialog = data.flag

    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/declaration-classified-income/index.js